// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4g-6";
export var headerCell = "_4g-2";
export var rowWrapper = "_4g-4";
export var stickyAggregationCell = "_4g-a";
export var stickyAggregationRow = "_4g-7";
export var stickyColumnCell = "_4g-9";
export var stickyColumnHeaderCell = "_4g-8";
export var table = "_4g-1";
export var virtualRowWrapper = "_4g-5";
export var virtualTableContainer = "_4g-0";
export var white = "_4g-3";